import { render } from "./Gameboard_Operational_Plan.vue?vue&type=template&id=001314aa"
import script from "./Gameboard_Operational_Plan.vue?vue&type=script&lang=js"
export * from "./Gameboard_Operational_Plan.vue?vue&type=script&lang=js"

import "./Gameboard_Operational_Plan.vue?vue&type=style&index=0&id=001314aa&lang=scss"
script.render = render

export default script